import { render, staticRenderFns } from "./dob-lock.vue?vue&type=template&id=a5e277e2&scoped=true&"
import script from "./dob-lock.vue?vue&type=script&lang=js&"
export * from "./dob-lock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e277e2",
  null
  
)

export default component.exports